module.exports = __webpack_public_path__ + "media/Audio16_f.8ef96fb5.wav";